<template>
  <tbody>
    <tr v-for="n in listLength" :key="n">
      <td class="text-left w-2"></td>
      <td class="w-14">
        <div class="flex items-center justify-center rounded bg-gray-300 opacity-60 w-10 h-10 ml-3"></div>
      </td>
      <td class="h-14 text-left">
        <div class="flex items-center justify-center rounded bg-gray-300 opacity-60 w-1/2 h-3 ml-3"></div>
      </td>
      <td class="w-30 text-left cursor-default hidden md:table-cell">
        <div class="flex items-center justify-center rounded bg-gray-300 opacity-60 w-3/4 h-3"></div>
      </td>
      <td class="w-25 xl:w-40 text-left cursor-default hidden sm:table-cell">
        <div class="flex items-center justify-center rounded bg-gray-300 opacity-60 w-3/4 h-3"></div>
      </td>
      <td class="w-1/4 text-left cursor-default pl-4 hidden md:table-cell">
        <div class="flex items-center justify-center rounded bg-gray-300 opacity-60 w-3/4 h-3"></div>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  name: "DocumentTableGhosts",

  props: ["options"],

  computed: {
    listLength() {
      if (!this.options.data || this.options.data.length === undefined) {
        return 4;
      }

      return this.options.data.length;
    }
  }
};
</script>
<style scoped>
div {
  background: linear-gradient(90deg, #bdbdbd, 8%, #e9e9e9 18%, #bdbdbd 30%);
  background-size: 600% 200%;
  animation: Animation 18s linear infinite;
}

div.f {
  animation-delay: 0s;
}

div.s {
  animation-delay: 0.9s;
}

div.t {
  animation-delay: 1.6s;
}

@-webkit-keyframes Animation {
  0% {
    background-position-x: 600%;
  }
  100% {
    background-position-x: 0%;
  }
}
</style>
